import { LinkProps } from 'react-router-dom';
import { StyledLinkButton } from './LinkButtonStyles';

export type ILinkButtonProps = LinkProps;

const LinkButton = ({ ...props }: ILinkButtonProps): JSX.Element => <StyledLinkButton {...props} />;

export default LinkButton;
